import { motion, AnimatePresence } from "framer-motion";

export function CookieConsent({ visible, onAccept }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-4 bottom-4 z-50 mx-auto max-w-xl rounded-2xl border border-dourado/25 bg-carddark/95 p-5 shadow-[0_20px_60px_rgba(0,0,0,0.6)] backdrop-blur-md sm:bottom-6"
        >
          <p className="text-sm leading-relaxed text-creme/85">
            Utilizamos cookies para melhorar sua experiência e, mediante seu
            consentimento, para medir a audiência e o desempenho das nossas
            campanhas. Ao aceitar, você concorda com esse uso.
          </p>
          <div className="mt-4 flex justify-end">
            <button
              type="button"
              data-testid="cookie-consent-accept"
              onClick={onAccept}
              className="rounded-full bg-dourado px-6 py-2.5 text-xs font-bold uppercase tracking-[0.15em] text-vinho transition-[transform,background-color] duration-300 hover:scale-105 hover:bg-[#F3E5C8]"
            >
              Aceitar
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
